import React from "react";
import { AppBar, Toolbar, Typography, Box, Container } from "@mui/material";
import { styled } from "@mui/material/styles";

const CompanyDiv = styled("div")(({ theme }) => ({
  fontSize: "24px",
  fontWeight: "700",
  letterSpacing: "1px",
  color: "#fff",
  fontFamily: "Poppins, sans-serif",
  "& span": {
    fontSize: "14px",
    fontWeight: "600",
    display: "block",
    marginTop: "-5px",
    opacity: 0.9
  },
}));

const PublicNavbar = ({ showTrackingTitle = false }) => {
  const loginData = localStorage.getItem("user");
  const loginValue = loginData ? JSON.parse(loginData) : null;
  const companyName = loginValue?.company_name || "SSS Auto";

  return (
    <AppBar position="sticky" sx={{ backgroundColor: "primary.main", boxShadow: 3 }}>
      <Container maxWidth="xl">
        <Toolbar
          disableGutters
          sx={{
            position: "relative",
            height: showTrackingTitle ? "auto" : 70,
            minHeight: { xs: 70 },
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            py: showTrackingTitle ? { xs: 1.5, sm: 0 } : 0,
            gap: { xs: 1, sm: 0 },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <CompanyDiv>
              {companyName}
              <span>SyncCare Tracking</span>
            </CompanyDiv>
          </Box>

          {showTrackingTitle && (
            <Box
              sx={{
                textAlign: "center",
                position: { xs: "static", sm: "absolute" },
                left: { sm: "50%" },
                top: { sm: "50%" },
                transform: { sm: "translate(-50%, -50%)" },
              }}
            >
              <Typography
                variant="h5"
                fontWeight="bold"
                sx={{
                  color: "#fff",
                  fontFamily: "Poppins",
                  fontSize: { xs: "1.25rem", sm: "1.5rem" },
                  lineHeight: 1.2,
                }}
              >
                Tracking Service
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "rgba(255,255,255,0.85)",
                  fontSize: { xs: "0.75rem", sm: "0.875rem" },
                }}
              >
                Stay updated with your delivery status in real-time.
              </Typography>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default PublicNavbar;
